import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOCAL_KEY = "wishlist_local_ids";

/**
 * Wishlist client.
 * - If user has email (logged in or known) → persist to backend.
 * - Otherwise → fallback to localStorage.
 */

function localGet() {
  try {
    const raw = localStorage.getItem(LOCAL_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch { return []; }
}

function localSet(ids) {
  try { localStorage.setItem(LOCAL_KEY, JSON.stringify(ids)); } catch { /* ignore */ }
  window.dispatchEvent(new CustomEvent("wishlist-changed", { detail: { ids } }));
}

export async function getWishlistIds(email) {
  if (!email) return localGet();
  try {
    const { data } = await axios.get(`${API}/wishlist`, { params: { email } });
    return data.ids || [];
  } catch {
    return localGet();
  }
}

export async function getWishlistProducts(email) {
  if (!email) {
    const ids = localGet();
    if (!ids.length) return [];
    const all = await axios.get(`${API}/products`).then((r) => r.data?.items || r.data || []);
    return all.filter((p) => ids.includes(p.id));
  }
  const { data } = await axios.get(`${API}/wishlist`, { params: { email } });
  return data.items || [];
}

export async function toggleWishlist(productId, email) {
  if (email) {
    const { data } = await axios.post(`${API}/wishlist/toggle`, { email, product_id: productId });
    window.dispatchEvent(new CustomEvent("wishlist-changed", { detail: { added: data.added, product_id: productId } }));
    return data.added;
  }
  // Local-only
  const ids = localGet();
  const idx = ids.indexOf(productId);
  if (idx >= 0) {
    ids.splice(idx, 1);
    localSet(ids);
    return false;
  }
  ids.push(productId);
  localSet(ids);
  return true;
}

export function isInLocalWishlist(productId) {
  return localGet().includes(productId);
}
